<section>
    <app-admin-header
      [header]="header"
      [links]="links"
      [breadcrumbs]="breadcrumbs"
      [stats]="stats"
    ></app-admin-header>
    <p-toast></p-toast>
    <!-- new ui section  -->
    <div class="container-fluid mb-5 mob-px-5" *ngIf="!skelition">
      <div class="row my-5">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="d-flex align-items-center gap-2 mob-my mb-3">
            <button
              class="v4-btn-every"
              (click)="createModal()"
            >
              <i class="pi pi-plus-circle mx-2"></i>{{ "New Announcements" | translator }}
            </button>

            <button
              class="v4-btn-every"
              (click)="createPopupAssessmentModal()"
            >
              <i class="pi pi-plus-circle mx-2"></i>{{ "New PopUp Assessment" | translator }}
            </button>
          </div>
         
          <div class="option-box-2">
            <div class="outer-wrapper">
              <div class="table-wrapper">
                <table class="mt-2 w-100">
                  <thead style="height: 60px">
                    <tr
                      class="mob-trr"
                      *ngIf="selectedAnnouncements.length == 0; else editHeader"
                    >
                      <th>
                        <input
                          type="checkbox"
                          [(ngModel)]="checkboxValue"
                          (ngModelChange)="markAll()"
                        />
                      </th>
                      <th class="table-row-mob-width">
                        {{ "Title" | translator }}
                      </th>
                      <th class="table-row-mob-width-name">
                        {{ "Created By" | translator }}
                      </th>
                      <th>{{ "Created" | translator }}</th>
                      <th>{{ "Modified" | translator }}</th>
                      <th>{{ "Start Date" | translator }}</th>
                      <th>{{ "End Date" | translator }}</th>
                      <th>{{ "Target Users" | translator }}</th>
                      <th>{{ "Status" | translator }}</th>
                      <th>{{ "Actions" | translator }}</th>
                    </tr>
                    <br />
                    <ng-template #editHeader>
                      <tr class="mob-trr">
                        <th>
                          <input
                            type="checkbox"
                            [(ngModel)]="checkboxValue"
                            (ngModelChange)="markAll()"
                          />
                        </th>
                        <th
                          class="table-row-mob-width d-flex flex-row gap-3 align-items-center"
                        >
                          <span
                            >{{ "selected" | translator }}
                            {{ selectedAnnouncements.length }}</span
                          >
                          <p-button
                            (onClick)="
                              announcementActionCall({ action: 'Delete', bulk: true })
                            "
                            styleClass="p-button-text"
                            icon="pi pi-trash"
                            label="{{ 'Delete' | translator }}"
                          ></p-button>
                        </th>
                      </tr>
                    </ng-template>
                  </thead>
                  <tbody *ngIf="announcements">
                    <tr
                      *ngFor="let announcement of announcements; let i = index"
                    >
                      <td data-label="factor">
                        <input
                          type="checkbox"
                          [(ngModel)]="announcement.selected"
                        />
                      </td>
                      <td
                        data-label="factor"
                        class="table-row-mob-width show-count d-flex flex-row gap-2 align-items-center"
                        style="color: rgb(172 172 223)"
                      >
                      <p-button *ngIf="announcement.assessmentId"
                        class="v4-ui"
                        (onClick)="openAssessmentPage(announcement)"
                        styleClass="p-button-rounded p-button-text"
                        icon="pi pi-file-edit"
                        [pTooltip]="'Edit Assessment' | translator"
                      ></p-button>
                        <p-button
                          class="v4-ui"
                          (onClick)="openResultsPage(announcement)"
                          styleClass="p-button-rounded p-button-text"
                          icon="pi pi-chart-bar"
                          [pTooltip]="'Results' | translator"
                        ></p-button>
                        <span
                          class="align-self-center"
                          style="font-size: 14px"
                          role="button"
                          >{{ announcement.title }}</span
                        >
                      </td>
                      <td>
                        {{ getName(announcement?.createdBy?.name) }}
                      </td>
                      <td data-label="factor">{{ announcement.createdAt | date }}</td>
                      <td data-label="factor">{{ announcement.updatedAt | date }}</td>
                      <td>{{ getTransformedDate(announcement.startDate) }}</td>
                      <td>{{ getTransformedDate(announcement.endDate) }}</td>
                      <td data-label="factor" [style]="{ 'text-align': 'center' }" >{{ announcement.targetUsers.length == 0 ? ('For All' | translator): (announcement.targetUsers.length == 1) ? 'مستخدم واحد' : (announcement.targetUsers.length == 2) ? 'مستخدمان' : announcement.targetUsers.length +' مستخدمين' }}</td>
                      <td>
                        <select
                          name="{{ announcement.active }}"
                          id="{{ announcement.active }}"
                          [(ngModel)]="announcement.active"
                          (ngModelChange)="updateAnnouncementData(announcement)"
                        >
                          <option
                            *ngFor="let option of statusOptions"
                            [value]="option.value"
                          >
                            {{ option.label }}
                          </option>
                        </select>
                      </td>
                      <td data-label="factor">
                        <p-menu
                          #menu
                          [model]="menuItems"
                          [popup]="true"
                          appendTo="body"
                        ></p-menu>
                        <p-button
                          class="v4-ui"
                          (onClick)="openAnnouncementMenu(menu, $event, announcement)"
                          styleClass="p-button-rounded p-button-text"
                          icon="pi pi-ellipsis-v"
                        ></p-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
  
    <!-- skelition   -->
    <app-skelitions
      [hidden]="!skelition"
      [value]="1"
      class="mb-2"
    ></app-skelitions>
  
    <!-- Confirm Modal -->
    <p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
  
    <!-- Update Data Modal -->
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="Header"
      [(visible)]="updateModal"
      (onHide)="onDialogClose()"
      [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1000px' }"
    >
      <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{ "Update announcement" | translator }}</span>
      </ng-template>
      <app-dynamic-form
        *ngIf="updateModal"
        [questions]="updateQuestions"
        (sendData)="updateAnnouncementData($event)"
      ></app-dynamic-form>
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </p-dialog>
  
    <!-- Create new Modal -->
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="Header"
      [(visible)]="openCreateModal"
      [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1200px' }"
      (onHide)="onDialogClose()"
    >
      <ng-template pTemplate="header">
        <span class="text-xl font-bold" [ngSwitch]="currentDialog">
          <span *ngSwitchCase="'announcement'">{{ "Create a new announcement" | translator }}</span>
          <span *ngSwitchCase="'popup-quiz'">{{ "New PopUp Assessment" | translator }}</span>
          <span *ngSwitchDefault>{{ "Default case" | translator }}</span>
        </span>
      </ng-template>
      <app-dynamic-form
        [questions]="questions"
        (sendData)="currentDialog === 'announcement' ? receiveAnnouncementData($event) 
               : currentDialog === 'popup-quiz' ? receiveAssessmentData($event) 
               : null"
      ></app-dynamic-form>
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </p-dialog>
  
    <app-footer></app-footer>
  </section>
  